<script type="text/javascript">
    // 定义一些公共的属性和方法
    
    //项目文件上传, 上传组件Url需要手动更改  upload上传链接
    
    
    //注册登录,权限页面
    import { envConfig } from '@root/env';
    
    const httpUrlRegAndLogin = `${envConfig.formalServer}/cotton/`;             //121.5.10.205


    //开发环境
    //const httpUrl = 'http://localhost:8079/source/'

    //正式环境    测试服务器 ---   项目上传, 项目发布, 项目下载, 项目删除,  项目文件夹删除,Other     http://1.117.248.202:8079/source/
    const httpUrl = `${envConfig.formalServer}/source/`;


    //负责正式服务器     ---   项目上传, 项目发布, 项目下载, 项目删除, 项目文件夹删除         http://121.5.10.205:8079/source/
    const httpFormalUploadUrl = `${envConfig.formalServer}/source/`;
    
    //防沉迷 - 测试服务器
    const httpAntiUrl = `${envConfig.formalServer}/cotton/`;

    // 暴露出这些属性和方法
    export default {
        httpUrlRegAndLogin,
        httpUrl,
        httpFormalUploadUrl,
        httpAntiUrl
    }
</script>